<template>
  <el-dialog
    :visible="visible"
    :title="title"
    width="400px"
    :before-close="handleClose"
    append-to-body
    custom-class="audio-player-dialog"
  >
    <div class="audio-player-content">
      <div class="audio-info">
        <div class="info-row">
          <span class="label">Origen:</span>
          <span class="value">{{ origin }}</span>
        </div>
        <div class="info-row">
          <span class="label">Destino:</span>
          <span class="value">{{ destination }}</span>
        </div>
        <div class="info-row">
          <span class="label">Fecha:</span>
          <span class="value">{{ formatDate(date) }}</span>
        </div>
      </div>
      <div class="audio-controls">
        <audio
          ref="audioPlayer"
          :src="audioUrl"
          controls
          class="audio-element"
          @play="handlePlay"
          @pause="handlePause"
          @ended="handleEnded"
        ></audio>
      </div>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import moment from "@/utils/moment";

const props = defineProps<{
  visible: boolean;
  audioUrl: string;
  title: string;
  origin: string;
  destination: string;
  date: Date;
}>();

const emit = defineEmits<{
  (e: "update:visible", value: boolean): void;
  (e: "play"): void;
  (e: "pause"): void;
  (e: "ended"): void;
}>();

const audioPlayer = ref<HTMLAudioElement | null>(null);

const handleClose = () => {
  emit("update:visible", false);
};

const handlePlay = () => {
  emit("play");
};

const handlePause = () => {
  emit("pause");
};

const handleEnded = () => {
  emit("ended");
};

const formatDate = (date: Date) => {
  return moment()(date).format("DD/MM/YYYY HH:mm");
};

watch(
  () => props.visible,
  (newValue) => {
    if (!newValue && audioPlayer.value) {
      audioPlayer.value.pause();
    }
  }
);
</script>

<style scoped>
.audio-player-dialog {
  border-radius: 8px;
  z-index: 3000 !important;
}

:deep(.v-modal) {
  z-index: 2999 !important;
}

.audio-player-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.audio-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-row {
  display: flex;
  gap: 8px;
}

.label {
  font-weight: bold;
  min-width: 60px;
}

.value {
  flex: 1;
}

.audio-controls {
  display: flex;
  justify-content: center;
}

.audio-element {
  width: 100%;
}
</style>
